(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_mobile-mega-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    function initMobileMenu() {
      var openBtn = document.querySelector('#open-mobile-menu .openMenu');
      var closeBtn = document.getElementById('close-mobile-menu');
      var menu = document.querySelector('.mobile-menu-outer-wrapper');
      var overlay = document.querySelector('.header-overlay');
      if (!menu || menu.dataset.menuBound) return;
      menu.dataset.menuBound = 'true';

      var scroller = menu.querySelector('.mobile-menu');

      function resetPanels() {
        var open = menu.querySelectorAll('.mobile-drilldown-panel.active');
        for (var i = 0; i < open.length; i++) {
          open[i].classList.remove('active');
          open[i].setAttribute('aria-hidden', 'true');
        }
        var triggers = menu.querySelectorAll('.mobile-drilldown-trigger');
        for (var j = 0; j < triggers.length; j++) {
          triggers[j].setAttribute('aria-expanded', 'false');
        }
        if (scroller) scroller.classList.remove('drilldown-open');
      }

      function closeMenu() {
        menu.classList.remove('active');
        document.body.classList.remove('mobile-menu-open');
        resetPanels();
      }
      function toggleMenu() {
        if (menu.classList.contains('active')) {
          closeMenu();
        } else {
          menu.classList.add('active');
          document.body.classList.add('mobile-menu-open');
        }
      }

      if (openBtn) openBtn.addEventListener('click', toggleMenu);
      if (closeBtn) closeBtn.addEventListener('click', closeMenu);
      if (overlay) overlay.addEventListener('click', closeMenu);

      // Drill-down: open a Level 2 panel
      var triggers = menu.querySelectorAll('.mobile-drilldown-trigger');
      for (var t = 0; t < triggers.length; t++) {
        triggers[t].addEventListener('click', function () {
          var panel = this.parentElement.querySelector('.mobile-drilldown-panel');
          if (!panel) return;
          panel.classList.add('active');
          panel.setAttribute('aria-hidden', 'false');
          this.setAttribute('aria-expanded', 'true');
          if (scroller) {
            scroller.scrollTop = 0;
            scroller.classList.add('drilldown-open');
          }
        });
      }

      // Drill-down: back to Level 1
      var backs = menu.querySelectorAll('.mobile-drilldown-back');
      for (var b = 0; b < backs.length; b++) {
        backs[b].addEventListener('click', function () {
          var panel = this.closest('.mobile-drilldown-panel');
          if (!panel) return;
          panel.classList.remove('active');
          panel.setAttribute('aria-hidden', 'true');
          var trigger = panel.parentElement.querySelector('.mobile-drilldown-trigger');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          if (scroller) scroller.classList.remove('drilldown-open');
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMobileMenu);
    } else {
      initMobileMenu();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
